export default {
  response: {
    'response.startCondition.value': {
      presence: {
        allowEmpty: false,
        message: '^Start Condition value must be selected'
      }
    },
    'response.stopCondition.value': {
      presence: {
        allowEmpty: false,
        message: '^Stop Condition value must be selected'
      }
    }
  },
  resolution: {
    'resolution.startCondition.value': {
      presence: {
        allowEmpty: false,
        message: '^Start Condition value must be selected'
      }
    },
    'resolution.stopCondition.value': {
      presence: {
        allowEmpty: false,
        message: '^Stop Condition value must be selected'
      }
    }
  }
};
